import { IconButton, Stack } from '@mui/material';
import { Add } from '@mui/icons-material';

import { SearchInput } from '/shared/SelectSearchList';

import { ISearchCustomInputProps } from '../../types';

export const SearchCustomInput = ({ value, onSearchInput, onClearClick, submitValue }: ISearchCustomInputProps) => {
  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && value.length) {
      e.preventDefault();
      submitValue(value);
    }
  };
  return (
    <Stack gap={1} direction='row' alignItems='center' pr={1}>
      <SearchInput value={value} onChange={onSearchInput} onClear={onClearClick} onKeyDown={onKeyDown} />
      <IconButton size='small' disabled={!value.length} onClick={() => submitValue(value)}>
        <Add />
      </IconButton>
    </Stack>
  );
};
